export const initialValues = {
  individualInfo: {
    name: "",
    personPresent: null,
    surname: null,
    fathersOrSpouseName: null,
    birthDate: "",
    age: null,
    healthInsurance: null,
    healthInsuranceDetails: null,
    gender: "",
    maritalStatus: null,
    mobileNumber: "",
    photo: "",
    individualIds: {
      HealthId: { idValue: "", maskedValue: null },
      Pan: { idValue: "", maskedValue: null },
      VoterID: { idValue: "", maskedValue: null },
      DrivingLicense: { idValue: "", maskedValue: null },
      SECC: { idValue: "", maskedValue: null },
      NPR: { idValue: "", maskedValue: null },
      uhcId: { idValue: "", maskedValue: null },
      HealthIdAlias: { idValue: "", maskedValue: null },
    },
    additionalDetails: {
      enrollmentDate: "",
      education: null,
      mobileOwner: null,
      residenceStatus: null,
      caste: null,
      casteOther: null,
      religion: null,
      religionOther: null,
      anmName: "",
      smsConsentNcd: true,
      smsConsentMProg: true,
      pvtgIndividual: null,
    },
  },
  familyInfo: {
    additionalDetails: {
      numberid: null,
      ASHA: "",
      hamlet: null,
      house: null,
      houseOther: null,
      toilet: null,
      toiletOther: null,
      water: null,
      waterOther: null,
      electricity: null,
      electricityOther: null,
      vehicle:null,
      vehicleOther: null,
      fuel: null,
      fuelOther: null,
      rationCardAPL: null,
      income: null,
      houseOwnershipStatus: null,
      ration: null,
      idOther: null,
      idOtherVal: null,
    },
    addressInfo: {
      landmark: null,
      addressDetails: null,
      subcenterName: "",
      subcenterId: null,
      village: "",
      villageId: null,
      phc: "",
      phcId: null,
      villageOther: null
    },
    familyHeadName: null,
    contactDetail: null,
  },
  enrollmentFormId: "",
};
